import { render } from "./admin-bulk-processing.vue?vue&type=template&id=11df2554&ts=true&lang=pug"
import script from "./admin-bulk-processing.vue?vue&type=script&lang=ts"
export * from "./admin-bulk-processing.vue?vue&type=script&lang=ts"

import "./admin-bulk-processing.vue?vue&type=style&index=0&id=11df2554&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__